import Home from "./pages/Home/Home.jsx";
import Packages from "./pages/Home/Packages.jsx";

let routes = [
  { path: `/`, element: <Home /> },
  { path: `/packages`, element: <Packages /> },
];

export default routes;
